export function collectQuestionParts(value: unknown,qid: string): unknown[] {
  const parts: unknown[] = []
  visit(value,item => { if (item.qid === qid) parts.push(item) })
  return parts
}
function visit(value: unknown,fn: (item: Record<string,unknown>) => void): void {
  if (Array.isArray(value)) { for (const child of value) visit(child,fn) }
  else if (value && typeof value === 'object') { fn(value as Record<string,unknown>); for (const child of Object.values(value)) visit(child,fn) }
}
